/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";



export const AuditFormsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { openEditObjectPage }
) => (
  <>
    {row.status === "Enable" && <OverlayTrigger
      overlay={<Tooltip id="objects-edit-tooltip">{"برای تکمیل پرسشنامه کلیک کنید"}</Tooltip>}
    >
      <a
        className="btn btn-light btn-hover-info btn-sm mx-3 text-primary"
        onClick={() => openEditObjectPage(row.id)}
      >

        <span className="svg-icon svg-icon-md svg-icon-info ">
          {row.auditFormTypeTitle}
        </span>
      </a>
    </OverlayTrigger>
    }

    {row.status === "EnableMustConfirm" && <OverlayTrigger
      overlay={<Tooltip id="objects-edit-tooltip">{"برای تایید پرسشنامه کلیک کنید"}</Tooltip>}
    >
      <a
        className="btn btn-light btn-hover-info btn-sm mx-3 text-primary"
        onClick={() => openEditObjectPage(row.id)}
      >

        <span className="svg-icon svg-icon-md svg-icon-info ">
          {row.auditFormTypeTitle}
        </span>
      </a>
    </OverlayTrigger>
    }


    {row.status === "Completed" && <OverlayTrigger
      overlay={<Tooltip id="objects-edit-tooltip">{"برای مشاهده پرسشنامه کلیک کنید"}</Tooltip>}
    >
      <a
        className="btn btn-light btn-hover-info btn-sm mx-3 text-gray"
        onClick={() => openEditObjectPage(row.id)}
      >

        <span className="svg-icon svg-icon-md svg-icon-info ">
          {row.auditFormTypeTitle}
        </span>
      </a>
    </OverlayTrigger>
    }

    {row.status !== "Enable" && row.status !== "Completed" && row.status !== "EnableMustConfirm" && <OverlayTrigger
      overlay={<Tooltip id="objects-edit-tooltip">{"برای تکمیل پرسشنامه کلیک کنید"}</Tooltip>}
    >
      <a
        className="btn btn-light btn-hover-info btn-sm mx-3 text-gray disabled"
      // onClick={() => openEditObjectPage(row.id)}
      >

        <span className="svg-icon svg-icon-md svg-icon-info ">
          {row.auditFormTypeTitle}
        </span>
      </a>
    </OverlayTrigger>
    }

  </>
);
